import { ChangeDetectionStrategy, Component, ElementRef } from "@angular/core";

@Component({
    selector: 'cs-note',
    templateUrl: 'cs-note.html',
    host: { 'class': 'note' },
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsNoteComponent {

  constructor(public elementRef: ElementRef) { }
}